import { Form } from '@/components/ui/form';
import { Loader2, Search } from 'lucide-react';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { InputControl } from '../controls/input-control';
import { Button } from '../ui/button';
import { Collapsible } from '../ui/collapsible';
import useFilter from './hooks/useFilter';
import { cn } from '@/lib/utils';
import RefreshIcon from '@/assets/Refresh';

interface IFilterProps {
  className?: string;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  isLoading?: boolean;
}

const Filter: FC<IFilterProps> = ({
  className,
  isOpen,
  setIsOpen,
  isLoading,
}) => {
  const { t } = useTranslation();
  const { form, handleForm, clearFilter } = useFilter();

  return (
    <Fragment>
      <Form {...form}>
        <form
          onSubmit={handleForm}
          className={cn('w-full h-[77px] py-1 px-3 bg-white', className)}
        >
          <div className="flex items-end justify-between gap-3">
            <Collapsible
              open={isOpen}
              onOpenChange={setIsOpen}
              className="w-full"
            >
              <div className="flex gap-5">
                <div className={'flex items-end gap-3'}>
                  <InputControl
                    className={'min-w-[200px] w-[200px]'}
                    control={form.control}
                    labelClass={'text-xs'}
                    name="id_number"
                    label={t('id.number')}
                    withoutDescription
                  />
                </div>
                <div className="flex items-end justify-between space-x-4">
                  <div className="flex gap-4">
                    <Button
                      type="submit"
                      variant="outline"
                      disabled={isLoading}
                      className={cn(
                        'p-[10px] active:translate-y-[1px] duration-200',
                      )}
                    >
                      {isLoading ? (
                        <Loader2 className="h-6 w-6 animate-spin text-primary" />
                      ) : (
                        <Search className="stroke-[#1976D2]" />
                      )}
                    </Button>
                    <Button
                      type="button"
                      variant="outline"
                      className=" p-[10px] active:translate-y-[1px] duration-200"
                      onClick={clearFilter}
                    >
                      <RefreshIcon />
                    </Button>
                  </div>
                </div>
              </div>
            </Collapsible>
          </div>
        </form>
      </Form>
    </Fragment>
  );
};

export default Filter;
